angular.module('impactx.reLoginExternal').service('ReloginExternalService', ReloginExternalService);

function ReloginExternalService() {
    var self = this;
    var buttonTranslation = "";
    var messageTranslation = "";
    var url = "";
    var urlUser = "";
    var isExternalUser = false;

    this.reset = function() {
        buttonTranslation = "";
        messageTranslation = "";
        url = "";
        isExternalUser = false;
    };

    this.initialize = function(newButtonTranslation, newMessageTranslation, newUrl, isExternal, newUrlUser) {
        buttonTranslation = newButtonTranslation;
        messageTranslation = newMessageTranslation;
        url = newUrl;
        isExternalUser = isExternal;
        urlUser = newUrlUser;
    };
    this.isExternalUser = function () {
        return isExternalUser;
    };

    this.getButtonTranslation = function() {
        return buttonTranslation;
    };

    this.getMessageTranslation = function() {
        return messageTranslation;
    };

    this.getUrl = function() {
        return url;
    }

    this.getUrlUser = function() {
        return urlUser;
    }
}
